import styled from "styled-components";

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.mediumGray};
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
`;

export const EmailInput = styled.input`
  min-height: 44px;
  padding: 0 ${({ theme }) => theme.spacing(3)};
  border: 1px solid ${({ theme }) => theme.colors.gray};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  font: inherit;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.darkBlue};
    outline-offset: 2px;
  }

  &[aria-invalid="true"] {
    border-color: ${({ theme }) => theme.colors.red};
  }
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.red};
  font-size: ${({ theme }) => theme.fontSizes.sm};
`;

export const Lead = styled.p`
  margin: 0 0 ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.colors.darkGray};
  line-height: 1.5;
`;

export const Notice = styled.p`
  color: ${({ theme }) => theme.colors.mediumGray};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1.5;

  a {
    color: ${({ theme }) => theme.colors.darkBlue};
  }
`;

export const SubmitButton = styled.button`
  min-height: 44px;
  border: 0;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.darkBlue};
  color: ${({ theme }) => theme.colors.white};
  font: inherit;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  cursor: pointer;
`;

export const WhyButton = styled.button`
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.darkBlue};
  font: inherit;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  text-decoration: underline;
  cursor: pointer;
`;

export const WhyText = styled.p`
  margin: 0;
  padding: ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  background: ${({ theme }) => theme.colors.lightGray};
  color: ${({ theme }) => theme.colors.mediumGray};
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 1.5;
`;

export const CancelButton = styled.button`
  min-height: 44px;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.mediumGray};
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
`;
